import { logout, login, getUserSession } from './../actions/user.action';
import { reducers, IReducers, EReducers } from './../reducers/index';
import { Store } from '@ngrx/store';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserState } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  constructor(private store: Store<IReducers>) {
    this.store.select(EReducers.USER).subscribe((user: UserState) => {
      this.isAuthenticated.next(user.loggedIn);
    });
  }

  onAuthentication(): BehaviorSubject<boolean> {
    return this.isAuthenticated;
  }

  logout(): void {
    this.store.dispatch(logout());
  }

  login(username, password): void {
    this.store.dispatch(
      login({
        username,
        password,
      })
    );
  }

  getUserSessionData(): void {
    this.store.dispatch(getUserSession());
  }
}
